import { Formik, ErrorMessage } from 'formik';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { validateWithdraw } from '../../utils/validateValues';
import { withdrawValues } from '../../utils/initialValues';
import useFetchCredential from '../../hooks/useFetchCredential';
import { formatter } from '../../utils/index';

const WithdrawForm = () => {
  const history = useNavigate();
  const successNotification = (message) => toast.success(message);
  const errorNotification = (message) => toast.error(message);

  const { data, loading, error } = useFetchCredential(
    `${process.env.REACT_APP_API_URL}/marketers/banks`
  );
  const { data: balanceData } = useFetchCredential(
    `${process.env.REACT_APP_API_URL}/marketers/commissions`
  );

  const initialValues = withdrawValues(balanceData?.pendingBalance);
  const validationSchema = validateWithdraw();

  const handleFormSubmit = async (values) => {
    const bank = values.bank;
    const accountName = bank.split(' - ')[0];
    const bankName = bank.split(' - ')[1];
    const accountNumber = bank.split(' - ')[2];
    const accountType = bank.split(' - ')[3];

    const res = await axios.post(`${process.env.REACT_APP_API_URL}/marketers/withdraw`, {
      amount: values.amount,
      bankName,
      accountName,
      accountNumber,
      accountType,
    });
    const response = res.data;
    if (res.status === 200) {
      successNotification(response.message);
      setTimeout(() => history('/banks'), 2000);
    } else {
      errorNotification(response.message);
    }
  };

  return (
    <div className="profileForm">
      {data && balanceData && (
        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div>
                <label htmlFor="amount">Current Balance</label>
                <input
                  name="amount"
                  value={formatter.format(balanceData.pendingBalance)}
                  disabled
                />
              </div>

              <div>
                <label htmlFor="amount">Amount</label>
                <input
                  type="text"
                  id="amount"
                  name="amount"
                  value={values.amount}
                  error={!!touched.amount && !!errors.amount}
                  helpertext={touched.amount && errors.amount}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter your bank name"
                />
                <ErrorMessage name="amount" component="span" className="error" />
              </div>

              <div>
                <label htmlFor="bank">Bank Details</label>
                {data.length < 1 ? (
                  <p>
                    No bank account available.{' '}
                    <Link to="/add-bank-account" target="_blank">
                      Add bank account
                    </Link>
                  </p>
                ) : (
                  <select
                    name="bank"
                    id="bank"
                    error={!!touched.bank && !!errors.bank}
                    helpertext={touched.bank && errors.bank}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.bank}
                  >
                    <option value="">Select Bank Details</option>
                    {data.map((bank, index) => (
                      <option
                        value={`${bank.accountName} - ${bank.bankName} - ${bank.accountNumber} - ${bank.accountType}`}
                        key={index}
                      >{`${bank.accountName} - ${bank.bankName} - ${bank.accountNumber}`}</option>
                    ))}
                  </select>
                )}
                <ErrorMessage name="bank" component="span" className="error" />
              </div>

              <button type="submit">Request Withdrawal</button>
            </form>
          )}
        </Formik>
      )}
      {loading && <div style={{ color: 'red !important', fontSize: '25px' }}>Loading...</div>}
      {error && <div style={{ color: 'red !important', fontSize: '25px' }}>{error}</div>}
    </div>
  );
};

export default WithdrawForm;
